<header class="shadow rounded bg-light">
  <div class="row">
    <div class="col-3">
      <br />
      <img priority [ngSrc]="logo" class="img-fluid" alt="GA header logo picture" height="97" width="421" />
    </div>
    <div class="col-7 text-center">
      <br />
      <h1 class=" fw-bold"> Georgia HIPP Program Online Application

      </h1>
      <strong>Fill out this form and click Submit to apply.</strong>
      <p>If you prefer to download a Georgia HIPP Program Application
        <a style="color: #064EBA;" lang="en" href="javascript:void(0)" 
        aria-label="download Georgia HIPP Program Application" 
        (click)="pdfData(applicationPdf, 'PaperApplication.pdf')">download application</a>
      </p>
      <p>If you prefer to download a Georgia HIPP Renewal Application
        <a style="color: #064EBA;" lang="en" href="javascript:void(0)" 
        aria-label="download Georgia HIPP Renewal Application"
        (click)="pdfData(renewalApplicationPdf, 'RenewalApplication.pdf')">click here</a>
      </p>
    </div>
    <div class="col-2"></div>
  </div>
</header>
<br />
<main>

  <app-gaform [preference]="preference" [errorMessageIntialData]="errorMessageIntialData" [email]="email"
    [mailingAddress]="mailingAddress" [emailTo]="emailTo" [faxNo]="faxNo" [tollfreeNo]="tollfreeNo"
    [dropingAddress]="dropingAddress" [mailingOffice]="mailingOffice" [mailingAddressLine]="mailingAddressLine"
    [mailingAddressLine2]="mailingAddressLine2" [mailingCityStateZip]="mailingCityStateZip"
    [empInsuranceDataPdf]="empInsuranceDataPdf" [documentChecklistPdf]="documentChecklistPdf"
    [authorizationFormPdf]="authorizationFormPdf" [faqFormPdf]="faqFormPdf" [eobYear]="eobYear"
    [cmoFaqPdf]="cmoFaqPdf"
    [benefitYear]="benefitYear" [consentForm]="consentForm" [benefitMonth]="benefitMonth"></app-gaform>


</main>
<br />
<footer class=" text-center bg-light">

  <p>
    Email <a target="_blank" [href]="emailTo" alt="Email" title="email" lang="en" style="color: #064EBA;">{{email}}</a>
    |
    Fax {{faxNo}} | Phone {{tollfreeNo}} Option 1 | Mail to {{mailingAddress}}
  </p>
  <div class="text-dark  p-3 bg-secondary bg-opacity-50 bg-gradient">HMS, Inc. All Rights Reserved</div>


</footer>

<ga-app-scroll-top></ga-app-scroll-top>